<template>
  <div class="main_sku">
    <div class="top_sku">采购订单</div>
    <el-table border
      style="width:100%"
      max-height:600
      :data="skuGoodsData"
      :cell-style="tc"
      :header-cell-style="tccolor"
      size="mini">
      <el-table-column label="商品图片">
        <template slot-scope="scope">
          <img style="width:56px;height:56px;object-fit:cover;"
            :src="scope.row.img_url"
            alt />
        </template>
      </el-table-column>
      <el-table-column label="商品名称"
        prop="title"></el-table-column>
      <el-table-column label="来源/供应商">
        <template slot-scope="scope">
          <div v-if="scope.row.supplier_channel">
            {{ scope.row.supplier_channel.name }}
          </div>
          <div v-else>--</div>
        </template>
      </el-table-column>
      <el-table-column label="接入方式">
        <template slot-scope="scope">
          <div v-if="scope.row.supplier_channel">
            <p v-if="scope.row.supplier_channel.type == 0">自营创建</p>
            <p v-if="scope.row.supplier_channel.type == 1">1688接入</p>
            <p v-if="scope.row.supplier_channel.type == 2">供应商接入</p>
          </div>
          <div v-else>--</div>
        </template>
      </el-table-column>
      <el-table-column label="规格属性">
        <template slot-scope="scope">
          <div v-if="scope.row.product_sku_attribute">
            <p v-for="item in scope.row.product_sku_attribute"
              :key="item.id">
              {{ item.attr_name }} : {{ item.attr_value }}
            </p>
          </div>
          <div v-else>---</div>
        </template>
      </el-table-column>
      <el-table-column label="数量">
        <!-- <template slot-scope="scope"> -->
        <input type="number"
          style="width:100px;height:36px;"
          @input="TotalAmount"
          min="1"
          max="1000000"
          v-model="out_quantity"
          class="el-input__inner" />
        <!-- </template> -->
      </el-table-column>
    </el-table>

    <div class="total_profit ">
      <span style="color:#f4222d;">¥ {{ (Number(supply_price) * Number(out_quantity)).toFixed(2) }}</span>

      <span>合计:</span>
    </div>

    <div class="top_sku">收货人信息</div>
    <table border
      class="after_table">
      <tr>
        <td>收货人</td>
        <td>
          <el-input size="mini"
            v-model="contact_name"
            placeholder="请输入收获人姓名"
            style='width:270px;'></el-input>
        </td>
      </tr>
      <tr>
        <td>联系电话</td>
        <td>
          <el-input size="mini"
            v-model="contact_phone"
            placeholder="请输入联系电话"
            style='width:270px;'></el-input>
        </td>
      </tr>
      <tr>
        <td>收获地址</td>
        <td>
          <el-select size="mini"
            v-model="provinceId"
            placeholder="省份"
            style="width:120px;"
            @change="selectProvince">
            <el-option v-for="item in provinceList"
              :key="'p' +item.id"
              :label="item.name"
              :value="item.id">

            </el-option>
          </el-select>
          <el-select size="mini"
            v-model="cityId"
            style="width:120px;"
            @change="selectCity"
            placeholder="地级市">
            <el-option v-for="item in cityList"
              :key="'p' +item.id"
              :label="item.name"
              :value="item.id">

            </el-option>
          </el-select>
          <el-select size="mini"
            v-model="areaId"
            style="width:120px;"
            placeholder="区县">
            <el-option v-for="item in areaList"
              :key="'p' +item.id"
              :label="item.name"
              :value="item.id">

            </el-option>
          </el-select>
          <el-input size="mini"
            v-model="address"
            placeholder="请输入详细收获地址"
            style='width:160px;'></el-input>
        </td>
      </tr>
    </table>

    <div style="margin:20px;">
      <el-button type="warning"
        size="mini"
        style="float:right;margin-left:12px;"
        @click="certainBuySkuOrder">采购下单</el-button>
      <el-button size="mini"
        style="float:right;margin-left:12px;"
        @click="cancelShowBuySku">取消</el-button>
    </div>
  </div>
</template>

<script>
// regionWithPid 
import { purchaseOrder, regionWithPid } from '@/api/goods'
export default {
  // props: ['skuId', 'visible', 'goodsId','attribute'],
  props: {
    skuId: { type: String, default: () => '' },
    visible: { type: Boolean, default: () => false },
    goodsId: { type: String, default: () => '' },
    attribute: { type: Array, default: () => [] },
    deailInfo: { type: Object, default: () => { } },
    supply_price: { type: String, default: () => '' }
  },
  data () {
    return {
      page: 1,
      size: 20,
      total: 0,
      showGoodsBuy: false,
      skuGoodsData: [],
      out_quantity: 1,

      contact_name: '',
      contact_phone: '',

      provinceId: '',
      cityId: '',
      areaId: '',
      province: '',
      city: '',
      area: '',
      address: '',

      provinceList: [],
      cityList: [],
      areaList: []
    }
  },
  mounted () {
    this.regionWithPidData('', 1)
  },
  watch: {
    skuId (newValue) {
      if (newValue) {
        this.skuGoodsData = []
        this.skuGoodsData.push({
          img_url: this.deailInfo.img_url,
          title: this.deailInfo.title,
          supplier_channel: this.deailInfo.supplier_channel,
          product_sku_attribute: this.attribute,
          quantity: this.out_quantity
        })
      }
    }
  },

  methods: {
    TotalAmount (e) {
      this.out_quantity = e.target.value
    },
    cancelShowBuySku () {
      this.out_quantity = 1,
        this.provinceId = this.areaId = this.cityId = ''
      this.cityList = this.areaList = []
      this.$emit('cancelShowBugSku')
    },

    certainBuySkuOrder () {
      if (Number(this.out_quantity < 1)) {
        this.$message.error('数量不能少于1件')
        return
      }

      if (!this.contact_name) {
        this.$message.error('收货人不能为空')
        return
      }

      if (!this.contact_phone) {
        this.$message.error('联系电话不能为空')
        return
      }


      if (!this.provinceId) {
        this.$message.error('请选择省')
        return
      }
      if (!this.cityId) {
        this.$message.error('请选择市')
        return
      }
      if (!this.areaId) {
        this.$message.error('请选择地区')
        return
      }


      if (!this.address) {
        this.$message.error('收获地址不能为空')
        return
      }
      this.provinceList.map(item => {
        if (item.id == this.provinceId) {
          this.province = item.name
        }
      })
      this.cityList.map(item => {
        if (item.id == this.cityId) {
          this.city = item.name
        }
      })
      this.areaList.map(item => {
        if (item.id == this.areaId) {
          this.area = item.name
        }
      })


      purchaseOrder({ product_id: this.goodsId, sku_id: this.skuId, quantity: this.out_quantity, contact_name: this.contact_name, contact_phone: this.contact_phone, province: this.province, city: this.city, area: this.area, address: this.address }).then(() => {
        this.$message.success('采购成功')
        this.cancelShowBuySku()
      })
    },
    selectProvince (e) {
      this.cityId = this.areaId = ''
      this.regionWithPidData(e, 2)
    },
    selectCity (e) {
      this.areaId = ''
      this.regionWithPidData(e, 3)
    },
    //收获地址,根据上级id获取详细地址
    async  regionWithPidData (pid, type) {
      let res = await regionWithPid({ pid: pid })
      if (type == 1) {
        this.provinceList = res
      } else if (type == 2) {
        this.cityList = res
      } else if (type == 3) {
        this.areaList = res
      }
    },

    tc () {
      return 'text-align:center; color:#333333; font-size:12px;'
    },
    tccolor () {
      return 'text-align:center;background-color:#f5f5f5; font-size:14px;'
    }
  }
}
</script>

<style lang="scss" scoped>
.main_sku {
	padding: 20px;

	.buy {
		cursor: pointer;
		font-size: 13px;
		color: rgb(253, 152, 64);
	}
	.top_sku {
		background-color: rgb(233, 233, 233);
		border: 1px solid rgb(228, 228, 228);
		height: 36px;
		line-height: 36px;
		padding-left: 20px;
		color: #333;
		font-size: 12px;
		font-weight: 500;
	}

	.total_profit {
		background-color: rgb(249, 250, 252);
		border: 1px solid rgb(228, 228, 228);
		height: 36px;
		line-height: 36px;
		span {
			float: right;
			margin-right: 12px;
			font-weight: 500;
			font-size: 16px;
		}
	}
	.after_table {
		border: 1px solid rgb(228, 228, 228);
		border-collapse: collapse;
		width: 100%;
		tr {
			height: 48px;
			td {
				border: 1px solid rgb(228, 228, 228);
				padding: 10px;
				font-size: 13px;
			}
			td:first-child {
				background-color: rgb(240, 242, 245);
				width: 160px;
				text-align: center;
				padding-right: 24px;
				font-weight: 500;
			}
			td:last-child {
				text-align: left;
				padding-left: 24px;
			}
		}
		tr:last-child {
			height: 72px;
		}
	}
}
</style>
